import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, OnInit, OnDestroy, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { FuseNavigationItem } from '../../../../core/models/interface/navigation.types';
import { FuseVerticalNavigationBasicItem } from '../fuse-vertical-navigation-basic-item/basic.component';

@Component({
    selector: 'fuse-vertical-navigation-collapsable-item',
    imports: [
        CommonModule,
        RouterModule,
        MatIconModule,
        MatTooltipModule,

        FuseVerticalNavigationBasicItem,
        //FuseVerticalNavigationCollapsableItem
    ],
    templateUrl: './collapsable.component.html',
})
export class FuseVerticalNavigationCollapsableItem implements OnInit, OnDestroy {
    @Output() manualCollapse = new EventEmitter<boolean>();
    @Input() autoCollapse!: boolean;
    @Input() item!: FuseNavigationItem;
    @Input() name!: string;

    isCollapsed: boolean = true;
    hasActiveChild: boolean = false;
    private router = inject(Router);
    private routerSubscription!: Subscription;

    ngOnInit() {
        this.checkActiveChild();
        this.routerSubscription = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.checkActiveChild();
        });
    }

    ngOnDestroy() {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
    }

    private checkActiveChild() {
        if (this.item && this.item.children) {
            this.hasActiveChild = this.item.children.some(child => 
                child.link && this.router.isActive(child.link, {
                    paths: 'subset',
                    queryParams: 'ignored',
                    fragment: 'ignored',
                    matrixParams: 'ignored'
                })
            );
            if (this.hasActiveChild) {
                this.isCollapsed = false;
            }
        } else {
            this.hasActiveChild = false;
        }
    }

    toggleCollapsable() {
        //console.log("toggleCollapsable");
        this.isCollapsed = !this.isCollapsed;

        this.manualCollapse.emit(this.isCollapsed);
    }
}
